import React from 'react';
import { N49LOGO } from '../constants';

export default class Footer extends React.Component {
    render() {
        return (
            <footer className='customer-portal-footer d-print-none'>
                <div className='div-container container-fluid'>
                    <div className='row'>
                        <div className='col-12 col-md-4 order-md-2'>
                            <a href="https://www.north49.com/customerportal/" style={{ marginTop: '-6px' }} target="_blank" rel="noopener noreferrer" className='justify-content-md-end  justify-content-center d-flex align-items-stretch text-decoration-none'>
                                <img src={N49LOGO} alt="Powered by North49" className='clickable footer-n49-logo' />
                            </a>
                        </div>
                        <div className='col-12 col-md-8'>
                            <div className='footer-company-info'>
                                <p className="company-address w-100"><i className="fa fa-building-o"></i> {this.props.address}</p>
                                <p className='company-info'>
                                    <span className='company-phone'><i className="fa fa-phone" />{this.props.phone}</span>
                                    <span className='company-separater'>|</span>
                                    <span className='company-url'><a href={(this.props.url||"").startsWith("http") ? (this.props.url) : ('http://' + this.props.url)} target="_blank">{this.props.url}</a></span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}
